import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-contact-select-dialog',
  templateUrl: './contact-select-dialog.component.html',
  styleUrls: ['./contact-select-dialog.component.scss']
})
export class ContactSelectDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {phone: string, email: string}
  ) { }

  ngOnInit(): void {
  }

}
